import { artistFormToQuery as formToQuery } from './artistFormToQuery';
import { artistQueryToForm as queryToForm } from './artistQueryToForm';

export default { queryToForm, formToQuery };
